import _ from 'lodash'

export const attributesStore = {
  namespaced: true,
  state: {
    /**
     * The selected attributes
     * @type {Array}
     */
    selected: [],

    /**
     * The attributes label
     * @type {Object}
     */
    labels: {},

    /**
     * All attributes
     * @type {Object}
     */
    all: {}
  },

  getters: {
    /**
     * Checks if an attribute is selected
     * @param  {obj} state Vuex state
     * @param  {obj} state Vuex getters
     * @param  {string} key   Country identifier
     * @return {Boolean}
     */
    getLabelFromKey: (state, getters) => (key) => {
      return _.find(state.labels, ['id', key])
    },

    /**
     * Returns the first selected attribute
     * @param  {Object} state attributesStore.state
     * @return {undefined|obj} The selected country object
     */
    firstSelected (state) {
      return state.selected[0]
    },

    /**
     * Checks if an attribute is selected
     * @param  {obj} state Vuex state
     * @param  {obj} state Vuex getters
     * @param  {string} key   Country identifier
     * @return {Boolean}
     */
    isSelected: (state, getters) => (key) => {
      let exists = (state.selected.indexOf(key) !== -1)
      return exists
    },

    /**
     * Checks if this attribute is selected
     * or if it contains a selected attribute
     *
     * @param  {obj} state Vuex state
     * @param  {obj} state Vuex getters
     * @param  {string} key   Country identifier
     * @return {Boolean}
     */
    isOrContainsSelected: (state, getters) => (key) => {
      let result = false
      if (getters.isSelected(key)) return true
      _.each(state.selected, (selectedKey) => {
        let section = getters.labelInfo(selectedKey, 'section')
        if (section === key) {
          result = true
        }
      })
      return result
    },

    /**
     * Return the name of a attributes
     * @param  {integer} id   The id
     * @param  {string} type The type: country,region or subregion
     * @return {undefined|String} The name of the value if found
     */
    labelInfo: (state, getters) => (key, info) => {
      let result = _.find(state.labels, ['id', key])
      if (!result || !result[info]) {
        return undefined
      } else {
        return result[info]
      }
    }
  },

  mutations: {
    /**
     * Add or remove a selected attributes
     * @param  {obj} state Vuex state
     * @param  {string} key   Country identifier
     * @return {void}
     */
    select (state, key) {
      state.selected.push(key)
    },

    /**
     * Unselect a attributes
     * @param  {obj} state Vuex state
     * @param  {string} key   Country identifier
     * @return {void}
     */
    unselect (state, key) {
      let index = state.selected.indexOf(key)
      state.selected.splice(index, 1)
    },

    /**
     * Resets the selected countries
     * @param  {[type]} state [description]
     * @return {[type]}       [description]
     */
    resetAllSelected (state) {
      state.selected = []
    }
  },

  actions: {
    /**
     * Toggels an attribute on/off
     * @param  {obj} options.state
     * @param  {obj} options.commit
     * @param  {obj} options.rootState
     * @param  {string} key
     * @return {void}
     */
    toggleSelect ({ state, commit, rootState }, key) {
      let exists = (state.selected.indexOf(key) !== -1)
      if (exists) {
        commit('unselect', key)
      } else {
        commit('select', key)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/attributesStore.js